import { ButtonActions } from './ButtonActions';
import { Title } from './Title';

export const Header = () => {
  return (
    <>
      <Title />
      <ButtonActions />
    </>
  );
};
